export const STORE_RESET_CODE = 'PasswordReset/STORE_RESET_CODE';
export const STORE_EMAIL = 'PasswordReset/STORE_EMAIL';
export const REQUEST_RESET_PASSWORD_PENDING = 'PasswordReset/REQUEST_RESET_PASSWORD_PENDING';
export const REQUEST_RESET_PASSWORD_SUCCESS = 'PasswordReset/REQUEST_RESET_PASSWORD_SUCCESS';
export const REQUEST_RESET_PASSWORD_FAILURE = 'PasswordReset/REQUEST_RESET_PASSWORD_FAILURE';
export const SET_NEW_PASSWORD_SUCCESS = 'PasswordReset/SET_NEW_PASSWORD_SUCCESS';
export const SET_NEW_PASSWORD_FAILURE = 'PasswordReset/SET_NEW_PASSWORD_FAILURE';
export const SUBMIT_SELFIE_FAILURE = 'PasswordReset/SUBMIT_SELFIE_FAILURE';
export const SUBMIT_SELFIE_SUCCESS = 'PasswordReset/SUBMIT_SELFIE_SUCCESS';
